import i18n from 'app-i18n';
import { isDateRangeValid } from 'components/forms/fields/date-range-field/date-range-field.utils';
import * as yup from 'yup';

export const setNormalHoursFormSchema = yup.object().shape({
  orderType: yup
    .array()
    .of(yup.string())
    .min(1, () =>
      i18n.t('forms.setNormalHoursForm.fields.orderType.errors.required'),
    ),
  daysOfWeek: yup.array().required().min(1),
  timeRange: yup
    .array()
    .required()
    .test(
      'validTimeRange',
      () =>
        i18n.t(
          'forms.setNormalHoursForm.fields.timeRange.errors.invalidTimeRange',
        ),
      isDateRangeValid,
    ),
});
